import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
} from "antd";
import {
  PlusOutlined,
  AuditOutlined,
  CalendarOutlined,
  InfoCircleOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";
import AddMerchantOrder from "./AddMerchantOrder";
import MerchantOrderDetails from "./MerchantOrderDetails";
import MerchantPaymentDetails from "./MerchantPaymentDetails";
import DeliveryFullDetails from "./DeliveryFullDetails";
import AddPushDelivery from "./AddPushDelivery";

const MerchantOrder = () => {
  const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [selectedTab, setSelectedTab] = useState("list");
  const [selectedData, setSelectedData] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openDrawerPayment, setOpenDrawerPayment] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState("all");

  const columns = [
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      render: (date) => (
        <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Merchant PO Number",
      dataIndex: "po_number",
      render: (text, record) => (
        <p
          style={
            {
              // textTransform: "uppercase",
              // fontWeight: "bold",
              // color: "blue",
            }
          }
          // onClick={() => console.log("record", record)}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Invoice Number",
      dataIndex: "invoice_number",
      render: (text, record) => (
        <p
          style={{
            color: "blue",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Payment Status",
      // dataIndex: "invoice_number",
      // sorter: (a, b) => a.dr_number - b.dr_number,
      align: "center",
      render: (text, record) => (
        <p
          style={{
            color:
              parseInt(text.payment_status) === 0
                ? "red"
                : parseInt(text.payment_status) === 1
                ? "green"
                : "orange",
            fontWeight: "bold",
          }}
        >
          {parseInt(text.payment_status) === 0
            ? "Unpaid"
            : parseInt(text.payment_status) === 1
            ? "Paid"
            : "Pending"}
        </p>
      ),
    },
    // {
    //   title: "Delivery Status",
    //   // dataIndex: "invoice_number",
    //   // sorter: (a, b) => a.dr_number - b.dr_number,
    //   align: "center",
    //   render: (text, record) => (
    //     <p>
    //       {text.deliverysavepoorder !== null
    //         ? text.deliverysavepoorder.po_status === "new"
    //           ? "P.O Placed"
    //           : text.deliverysavepoorder.po_status === "acknowledge"
    //           ? "Acknowledged"
    //           : text.deliverysavepoorder.po_status === "preparing"
    //           ? "Preparing"
    //           : text.deliverysavepoorder.po_status === "ready"
    //           ? "Ready To Deliver"
    //           : text.deliverysavepoorder.po_status === "in-transit"
    //           ? "In Transit"
    //           : text.deliverysavepoorder.po_status === "arrived"
    //           ? "Arrived"
    //           : "Completed"
    //         : ""}
    //     </p>
    //   ),
    // },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ width: window.innerWidth > 575 ? "auto" : 90 }}>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>

          {parseInt(text.payment_status) === 1 && (
            <Tooltip title="Payment Details">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedData(text);
                  setOpenDrawerPayment(true);
                }}
                icon={<InfoCircleOutlined />}
              />
            </Tooltip>
          )}
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantOrderSaveList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/merchant-order-save-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantOrderSaveList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantOrderSaveList();
  }, [getMerchantOrderSaveList]);

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return data.invoice_number.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  const handleFilter = (values) => {
    console.log("values", values);

    var params = {
      date_from: moment(new Date(values.date_from), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      date_to: moment(new Date(values.date_to), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      user_id: userData.data.id,
      payment_status: selectedPaymentStatus,
    };
    setLoading(true);
    axios
      .get("user/commissary/filter/merchant-order-save-list", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Filter successful.");
        setTimeout(() => {
          setOpenFilterByDate(false);
          setLoading(false);
          setMerchantOrderSaveList({ data, ready: true });
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  return (
    <div>
      {selectedTab === "list" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Input
                placeholder="Search invoice #"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  border: "2px solid #e5e5e5",
                  width: window.innerWidth < 576 ? "100%" : 300,
                }}
                size="large"
              />
            </div>

            {/* <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setSelectedTab("form")}
            >
              Add Delivery
            </Button> */}

            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setSelectedTab("push-deliver")}
            >
              Push Delivery
            </Button>

            <Tooltip title="Filter by date">
              <Button
                icon={<CalendarOutlined />}
                style={{
                  marginLeft: 5,
                  marginRight: 5,
                }}
                onClick={() => setOpenFilterByDate(true)}
              >
                Filter
              </Button>
            </Tooltip>

            <Tooltip title="Full Details">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedTab("fulldetails");
                }}
                icon={<ArrowRightOutlined />}
              />
            </Tooltip>
          </div>

          <div style={{ overflowX: "auto" }}>
            <Table
              {...tableProps}
              pagination={{
                position: ["bottomCenter"],
              }}
              columns={tableColumns}
              dataSource={searchable.length > 0 ? searchable : []}
              scroll={scroll}
              rowKey={(record) => record.invoice_number}
            />
          </div>
        </>
      )}
      {selectedTab === "form" && (
        <AddMerchantOrder
          close={() => setSelectedTab("list")}
          getMerchantOrderSaveList={() => getMerchantOrderSaveList()}
        />
      )}

      {selectedTab === "push-deliver" && (
        <AddPushDelivery
          close={() => setSelectedTab("list")}
          getMerchantOrderSaveList={() => getMerchantOrderSaveList()}
        />
      )}

      {selectedTab === "fulldetails" && (
        <DeliveryFullDetails close={() => setSelectedTab("list")} />
      )}

      {openDrawer && (
        <MerchantOrderDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
          getMerchantOrderSaveList={() => getMerchantOrderSaveList()}
        />
      )}

      {openDrawerPayment && (
        <MerchantPaymentDetails
          open={openDrawerPayment}
          close={() => setOpenDrawerPayment(false)}
          selectedData={selectedData}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
      >
        <Form
          layout="vertical"
          name="basic"
          initialValues={{ payment_status: selectedPaymentStatus }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="payment_status"
              label="Payment Status"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Payment Status"
                onChange={(e) => setSelectedPaymentStatus(e)}
                size="large"
                showSearch
              >
                <Select.Option value={"all"}>All</Select.Option>
                <Select.Option value={"unpaid"}>Unpaid</Select.Option>
                <Select.Option value={"paid"}>Paid</Select.Option>
              </Select>
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MerchantOrder;
